import React from 'react';
import { useScrollReveal } from '../../hooks/useScrollReveal';
import styles from './SmallBox.module.css';

const SmallBox = ({ text, number }) => {
  const numberRef = useScrollReveal({
    origin: 'right',
    distance: 30,
    duration: 1000,
    delay: 200,
    threshold: 0.2,
  });

  return (
    <div className={styles.container}>
      <div className={styles.number} ref={numberRef}>{number}</div>
      <p className={styles.text}>{text}</p>
    </div>
  );
};

export default SmallBox;
